import * as mapManagmentActions from '@Actions/mapManagement';
import { error as notificationError, success } from '@innovyze/stylovyze';

import { put, retry, takeEvery, takeLatest } from 'redux-saga/effects';

import { AxiosResponse } from 'axios';
import { ThemeListResponse } from '@Types/mapManagement.types';
import {
	getThemeList,
	regenerateAssetTiles,
	regenerateInspectionTiles,
	regenerateSensorTiles,
} from '@Services/mapManagement';

function* getThemeListSaga() {
	try {
		const response: AxiosResponse<ThemeListResponse> = yield retry(
			5,
			1500,
			getThemeList,
		);
		if (response.data) {
			yield put(mapManagmentActions.getThemeListResolved(response.data));
		} else {
			yield put(mapManagmentActions.getThemeListRejected());
		}
	} catch (error) {
		yield put(mapManagmentActions.getThemeListRejected());
	}
}

function* regenerateAssetTilesSaga() {
	try {
		yield regenerateAssetTiles();
		yield put(success('Started Regenerating Asset Tiles'));
		yield put(mapManagmentActions.regenerateAssetTilesResolved());
	} catch (error) {
		yield put(notificationError('Error Regenerating Asset Tiles'));
		yield put(mapManagmentActions.regenerateAssetTilesRejected());
	}
}

function* regenerateSensorTilesSaga() {
	try {
		yield regenerateSensorTiles();
		yield put(success('Started Regenerating Sensor Tiles'));
		yield put(mapManagmentActions.regenerateSensorTilesResolved());
	} catch (error) {
		yield put(notificationError('Error Regenerating Sensor Tiles'));
		yield put(mapManagmentActions.regenerateSensorTilesRejected());
	}
}

function* regenerateInspectionTilesSaga() {
	try {
		yield regenerateInspectionTiles();
		yield put(success('Started Regenerating Inspection Tiles'));
		yield put(mapManagmentActions.regenerateInspectionTilesResolved());
	} catch (error) {
		yield put(notificationError('Error Regenerating Inspection Tiles'));
		yield put(mapManagmentActions.regenerateInspectionTilesRejected());
	}
}

function* watchGetThemeList() {
	yield takeEvery(
		mapManagmentActions.getThemeList.toString(),
		getThemeListSaga,
	);
	yield takeLatest(
		mapManagmentActions.regenerateAssetTiles.toString(),
		regenerateAssetTilesSaga,
	);
	yield takeLatest(
		mapManagmentActions.regenerateSensorTiles.toString(),
		regenerateSensorTilesSaga,
	);
	yield takeLatest(
		mapManagmentActions.regenerateInspectionTiles.toString(),
		regenerateInspectionTilesSaga,
	);
}

export default [watchGetThemeList()];
